<p-avatar
  styleClass="mr-2"
  shape="circle"
  size="large"
  label="{{ username.split(' ')[0][0] }}"
></p-avatar>
